import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  NgZone,
  OnChanges,
  OnInit,
} from '@angular/core';
import { SideBarItem } from './sideMenuItem';
import { AuthRepository, getStoredToken } from 'app/state/auth.repository';
import { EnvState } from 'app/modules/shared/helpers/env-state';
import { UiRepository } from 'app/state/ui.repository';
import {
  GeneralAppDataDto,
  TenantMenuItemData,
} from 'app/api/models/auth/sideBarInfoDto';
import { AuthService } from 'app/state/auth.service';
import { GeneralDataRepository } from '../../../../../helpers/repository/general-data.repository';
import { DocumentTypesRepository } from 'app/state/documenttype.repository';
import { DatalistOption } from 'app/state/abstract/base.repository';
import { Router } from '@angular/router';
import { LocalStorageService } from 'app/api/services/local-storage-service';
import { NotificationsService } from 'app/state/notifications.service';
import { combineLatest, filter, forkJoin, take } from 'rxjs';
import { NotificationsRepository } from 'app/state/notifications.repository';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { DocumentTypesService } from 'app/state/documenttype.service';
import { UiEventsService } from 'app/api/services/signal.service';

@UntilDestroy()
@Component({
  selector: 'app-sidebar-items',
  templateUrl: './sidebarItems.component.html',
  styleUrls: ['./sidebarItems.component.scss'],
})
export class SidebarItemsComponent implements OnInit {
  allMainSideMenuItems: Array<SideBarItem> = [];
  allIgniteSideMenuItems: Array<SideBarItem> = [];
  allAdminSideMenuItems: Array<SideBarItem> = [];

  sidebarData: GeneralAppDataDto = new GeneralAppDataDto();
  tenantsOptions: Array<DatalistOption> = [];
  featuresData: Array<TenantMenuItemData> = [];
  tenantId: string | null = null;
  notificationsCount: any;

  constructor(
    public env: EnvState,
    public ui: UiRepository,
    private auth: AuthService,
    public repo: AuthRepository,
    public generalDataRepo: GeneralDataRepository,
    public doctypesRepo: DocumentTypesRepository,
    public router: Router,
    private storage: LocalStorageService,
    private notificationsService: NotificationsRepository,
    private zone: NgZone,
    public doctypesService: DocumentTypesService,
    private uiEvents: UiEventsService,
  ) {}
  ngOnInit(): void {
    this.generalDataRepo.updateAllGeneralData();

    combineLatest([
      this.generalDataRepo.allGeneralData$,
      this.generalDataRepo.allMainSideMenuItems$,
      this.generalDataRepo.allIgniteSideMenuItems$,
      this.generalDataRepo.allAdminSideMenuItems$,
      this.notificationsService.notificationCount$,
    ])
      .pipe(untilDestroyed(this))
      .subscribe(
        ([
          generalData,
          mainItems,
          igniteItems,
          adminItems,
          notificationCount,
        ]) => {
          this.featuresData = generalData.tenantMenuItemsData;

          if (notificationCount) {
            this.notificationsCount = notificationCount;

            window.dispatchEvent(new Event('resize'));
          }

          const updateItems = (items: any[]) => {
            items.forEach((item) => {
              this.getItemName(item);
            });
          };

          const notification = mainItems.filter(
            (i) => i.title === 'notifications',
          );
          const others = mainItems.filter((i) => i.title !== 'notifications');
          [...others, ...notification].forEach((item) => {
            const match = notificationCount.find(
              (n: any) => n.groupName == item.title,
            );
            item.notificationsCount = match ? match.count : 0;
          });
          this.allMainSideMenuItems = [...others, ...notification];
          this.allIgniteSideMenuItems = igniteItems;
          this.allAdminSideMenuItems = adminItems;

          this.crm =
            this.allMainSideMenuItems.filter((x) =>
              x.title.toLocaleLowerCase().includes('crm'),
            ).length > 0;

          this.allMainSideMenuItems = this.allMainSideMenuItems.filter(
            (x) => !x.title.toLocaleLowerCase().includes('crm'),
          );
          updateItems(this.allMainSideMenuItems);
          updateItems(this.allIgniteSideMenuItems);
          updateItems(this.allAdminSideMenuItems);
        },
      );

    combineLatest([
      this.generalDataRepo.tenantsOptions$,
      this.storage.getTenantId$(),
    ])
      .pipe(untilDestroyed(this))
      .subscribe(([items, id]) => {
        this.tenantsOptions = [...items].sort((a, b) =>
          a.label.localeCompare(b.label),
        );

        this.tenantId = id;
      });
  }

  crm = false;

  menuclose(item?: SideBarItem) {
    this.ui.toggleMenuOpened(false);

    if (item?.displayedName == 'dataroom') {
      this.uiEvents.emitAction();
    }
  }

  setActiveTenant(tenantId?: any) {
    this.tenantId = tenantId;
    if (this.tenantId) {
      localStorage.setItem('activeTenantId', this.tenantId);
    } else {
      localStorage.removeItem('activeTenantId');
    }
    let token = getStoredToken();
    this.auth.setActiveTenant(token!, tenantId).subscribe(() => {
      this.storage.setTenantId(tenantId);
      this.generalDataRepo.updateAllGeneralData(true);
      this.router.navigate(['/home']).then(() => {
        //window.location.reload();
        //this.generalDataRepo.updateAllGeneralData(true);
      });
    });
  }

  getItemName(inputItem: SideBarItem) {
    inputItem.displayedName = inputItem.title;
    if (inputItem) {
      const featureData = this.featuresData.find(
        (data) =>
          data.name.toLocaleLowerCase() === inputItem.title.toLocaleLowerCase(),
      );

      if (featureData) {
        inputItem.displayedName =
          featureData.customTitle || featureData.name.toLocaleLowerCase();
      }
    }
  }
}
